/**
 * Article rédigé le 2026-09-06 à partir de sources web ouvertes et vérifiées automatiquement
 * (6 URL testées, révisé après vérification). Daté au moment des faits : 2026-05-13.
 * À relire avant/après mise en ligne. Format : voir src/blog/README.md
 */
export default {
  "slug": "french-tech-bfc-capitale-2026-2028-besancon",
  "title": "La French Tech BFC reste Capitale jusqu'en 2028 : ce que Besançon y gagne",
  "excerpt": "La Mission French Tech a dévoilé début mai son réseau 2026-2028. La Bourgogne-Franche-Comté garde son rang de Capitale : un cadre qui structurera l'écosystème bisontin pour trois ans.",
  "seoTitle": "French Tech BFC : Capitale jusqu'en 2028",
  "seoDescription": "La Mission French Tech a renouvelé le 6 mai 2026 le label Capitale pour la Bourgogne-Franche-Comté sur 2026-2028 : 264 start-up et 3 300 emplois concernés.",
  "category": "startups",
  "tags": [
    "French Tech",
    "Bourgogne-Franche-Comté",
    "Mission French Tech",
    "Le Numérique",
    "Planoise"
  ],
  "author": "jimmy",
  "publishedAt": "2026-05-13",
  "updatedAt": "2026-07-06",
  "featured": false,
  "cover": {
    "image": "/img/blog/20100220-temis-103-4373029463.jpg",
    "credit": "Photo : TEMIS Innovation - Maison des Microtechniques, Besançon - Régions Démocrates 2010, CC BY 2.0, via Wikimedia Commons",
    "alt": "Façade entièrement vitrée du bâtiment TEMIS Innovation - Maison des Microtechniques, à Besançon : le nom TEMIS en lettres bleues et le mot INNOVATION en rouge se détachent sur les vitres, qui reflètent les bâtiments voisins de la technopole sous un ciel gris."
  },
  "content": [
    {
      "type": "lead",
      "text": "La Mission French Tech a publié le 6 mai la composition de son réseau pour la période 2026-2028[^1]. La French Tech Bourgogne-Franche-Comté y conserve son rang de Capitale, aux côtés de dix-huit autres territoires[^2]. Pour Besançon, l'information vaut moins comme un trophée que comme un cadre : celui dans lequel s'inscriront les trois prochaines années de l'écosystème tech local, au moment où sort de terre le futur bâtiment « Le Numérique » à Planoise."
    },
    {
      "type": "keyfacts",
      "facts": [
        {
          "label": "Quoi",
          "value": "Renouvellement du label Capitale French Tech pour la Bourgogne-Franche-Comté"
        },
        {
          "label": "Quand",
          "value": "Annonce nationale le 6 mai 2026, pour la période 2026-2028"
        },
        {
          "label": "Où",
          "value": "19 Capitales et 28 Communautés en France, 78 Communautés dans 57 pays"
        },
        {
          "label": "Qui",
          "value": "La Mission French Tech, rattachée au ministère de l'Économie, et l'association La French Tech Bourgogne-Franche-Comté"
        },
        {
          "label": "Pour qui",
          "value": "264 start-up régionales et environ 3 300 emplois liés à l'écosystème tech"
        }
      ]
    },
    {
      "type": "h2",
      "text": "Un troisième cycle de labellisation, plus large qu'avant"
    },
    {
      "type": "p",
      "text": "La French Tech n'est pas un guichet de subventions : c'est un label d'État, porté par une mission rattachée à la direction générale des entreprises, au sein du ministère de l'Économie et des Finances[^3]. Tous les trois ans, elle redistribue ses cartes en désignant des Capitales — les pôles régionaux — et des Communautés, en France et à l'étranger."
    },
    {
      "type": "p",
      "text": "Le millésime 2026-2028 compte 19 Capitales et 28 Communautés sur le territoire national, auxquelles s'ajoutent 78 Communautés réparties dans 57 pays[^2]. Deux territoires accèdent pour la première fois au rang de Capitale, la Normandie et la Nouvelle-Calédonie, après plusieurs années de structuration comme Communautés[^3]. À l'international, quinze nouvelles implantations apparaissent, des États-Unis à l'Arménie en passant par le Chili[^3]. L'ensemble repose sur 1 100 bénévoles, dont plus de 40 % de femmes, et fédère quelque 3 000 start-up[^2][^3]."
    },
    {
      "type": "h2",
      "text": "Ce que le label engage réellement"
    },
    {
      "type": "p",
      "text": "Être Capitale, c'est d'abord un mandat d'animation. La Mission French Tech décrit l'objectif du réseau comme celui de « fédérer et animer les acteurs de l'innovation de leur territoire » et de les mobiliser autour d'initiatives communes[^2]. Leur connaissance fine des territoires en fait, toujours selon la Mission, des partenaires privilégiés pour la mise en œuvre des politiques publiques, et des facilitateurs du dialogue avec les institutions[^2]."
    },
    {
      "type": "p",
      "text": "Le cadre fixé pour 2026-2028 est resserré autour de trois chantiers :"
    },
    {
      "type": "ul",
      "items": [
        "**Faciliter l'accès des start-up à la commande publique et à l'achat privé**, c'est-à-dire aux premiers clients — souvent le maillon le plus difficile pour une jeune entreprise régionale[^3] ;",
        "**Mettre en avant les secteurs tech structurants de chaque territoire** afin de renforcer leur attractivité auprès des fonds d'investissement[^3] ;",
        "**Contribuer à la souveraineté technologique française**, en accompagnant les entreprises sur le déploiement de l'intelligence artificielle, l'industrialisation et les liens avec la recherche[^3]."
      ]
    },
    {
      "type": "p",
      "text": "Sur le volet financement, l'association régionale dispose déjà d'un outil dédié : le dispositif *Meet Your VC*, qui organise des rencontres régulières entre un investisseur et ses adhérents. Chaque séance est suivie de rendez-vous individuels entre le fonds et les start-up qu'il a sélectionnées[^4]. C'est peu spectaculaire, mais c'est exactement le type de passerelle qui manque le plus loin des grandes métropoles."
    },
    {
      "type": "h2",
      "text": "Le poids réel de la région"
    },
    {
      "type": "p",
      "text": "Les chiffres publiés à l'appui de la labellisation donnent la mesure : 264 start-up en Bourgogne-Franche-Comté et environ 3 300 emplois générés par l'écosystème tech local — « 3,3 k » dans le décompte de la Mission French Tech[^3]. La région était déjà Capitale French Tech pour le cycle précédent, entamé en 2024[^3]. Deux entreprises sont citées comme emblématiques du territoire — Weezevent (French Tech Next40) et Matawan (French Tech 120) —, auxquelles s'ajoute une usine implantée en région, celle de TSE, également labellisée French Tech 120[^3]."
    },
    {
      "type": "p",
      "text": "Ces volumes restent modestes rapportés aux 18 000 start-up et 450 000 emplois que revendique la French Tech à l'échelle nationale[^3]. La Bourgogne-Franche-Comté joue ainsi dans la catégorie des écosystèmes intermédiaires, où l'enjeu tient moins au nombre de créations qu'à la capacité à faire grandir les entreprises sur place."
    },
    {
      "type": "h2",
      "text": "Besançon : un ancrage qui se construit rue du Luxembourg"
    },
    {
      "type": "p",
      "text": "C'est là que l'annonce rejoint un chantier bien concret. À Planoise, sur l'ancien site des immeubles des Charmettes démolis en 2022, Grand Besançon Métropole fait construire « [Le Numérique](/blog/premiere-pierre-le-numerique-planoise-besancon) », un bâtiment de quelque 3 000 m² aux 9-11 rue du Luxembourg[^5][^6]. La collectivité le présente sans détour comme le futur « lieu totem » d'une de ses filières d'excellence — le numérique — et de la French Tech[^6]."
    },
    {
      "type": "p",
      "text": "Le programme mêle usages grand public et hébergement d'entreprises : un rez-de-chaussée vitré dédié à un tiers-lieu de formation et d'accompagnement aux démarches en ligne, un FabLab équipé de machines numériques, une salle immersive à 360°, une salle des hôtes pour conférences et séminaires, puis à l'étage des espaces de coworking, des bureaux et des open spaces en location[^5]. Le bâtiment vise le label R2S, référentiel des immeubles connectés et sobres[^6]."
    },
    {
      "type": "p",
      "text": "Le coût total s'élève à 10,5 millions d'euros, répartis entre l'ANRU (1,5 M€ au titre de la convention pluriannuelle et 1,2 M€ au titre du volet « quartier d'excellence numérique »), la Région Bourgogne-Franche-Comté (2,8 M€), Grand Besançon Métropole (2 M€) et un prêt renouvellement urbain de la Banque des Territoires (2,3 M€)[^5]. Le chantier a démarré en novembre 2025[^6] pour une ouverture annoncée d'ici 2027[^5], mi-2027 selon la collectivité[^6]."
    },
    {
      "type": "callout",
      "tone": "tip",
      "title": "Pourquoi ça compte pour Besançon",
      "text": "Un label ne crée pas d'entreprises. Mais il fixe une adresse institutionnelle, un interlocuteur identifié face à l'État et aux financeurs, et une continuité de trois ans. Pour Besançon, l'enjeu des prochains mois est d'articuler ce cadre régional avec l'équipement physique en construction à Planoise : sans lieu, une communauté reste un carnet d'adresses ; sans communauté, un bâtiment reste des mètres carrés."
    },
    {
      "type": "h2",
      "text": "Ce qu'il faudra suivre"
    },
    {
      "type": "p",
      "text": "Trois points mériteront d'être vérifiés d'ici la fin de l'année : la manière dont l'association régionale déclinera concrètement ses engagements à l'échelle bisontine, le calendrier de livraison du bâtiment de Planoise, et le contenu opérationnel du volet « accès aux marchés », de loin le plus difficile à mettre en œuvre. Le label est acquis jusqu'en 2028 ; le reste demande à être construit."
    },
    {
      "type": "h2",
      "text": "Mise à jour — juillet 2026 : sept lauréats régionaux au Tremplin Incubation"
    },
    {
      "type": "p",
      "text": "Deux mois après la reconduction du label, le réseau régional a donné une première mesure concrète de son activité. Le 3 juillet 2026, la Mission French Tech a dévoilé à [VivaTech](/blog/vivatech-2026-percipio-robotics-startups-bfc) les 102 entreprises retenues pour la 5ᵉ promotion de **French Tech Tremplin Incubation**.[^7] Sept d'entre elles sont rattachées à la Capitale French Tech Bourgogne-Franche-Comté : **ARENIA**, **CENTAGA SAVEY**, **HILAJO GROUP**, **INTELLECTUALITY**, **MATERN'UP**, **MEND ME** et **SIGN ON**.[^8]"
    },
    {
      "type": "p",
      "text": "La dernière est bisontine : SIGN ON, fondée par [Mehdi Mougin](/blog/mehdi-mougin-signon-french-tech-tremplin-besancon), développe un traducteur automatique de la langue des signes française. Le même porteur de projet avait déjà reçu, en décembre 2025, le coup de cœur du public de la promotion Tremplin Prépa régionale."
    }
  ],
  "references": [
    {
      "id": 1,
      "title": "DP – Découvrez les Capitales et Communautés du réseau French Tech pour la période 2026-2028",
      "publisher": "Ministère de l'Économie, des Finances et de la Souveraineté industrielle et numérique",
      "url": "https://presse.economie.gouv.fr/dp-decouvrez-les-capitales-amp-communautes-du-reseau-french-tech-pour-la-periode-2026-2028/",
      "type": "official",
      "date": "2026-05-06"
    },
    {
      "id": 2,
      "title": "Labellisation 2026-2028 des Capitales et Communautés French Tech",
      "publisher": "La Mission French Tech",
      "url": "https://lafrenchtech.gouv.fr/fr/labellisation-2026-2028-des-capitales-et-communautes-french-tech/",
      "type": "official",
      "date": ""
    },
    {
      "id": 3,
      "title": "La French Tech confirme le dynamisme de la Bourgogne-Franche-Comté pour la période 2026-2028",
      "publisher": "Info-Beaune",
      "url": "https://www.info-beaune.com/articles/2026/05/10/15250/la-french-tech-confirme-le-dynamisme-de-la-bourgogne-franche-comte-pour-la-periode-2026-2028/",
      "type": "press",
      "date": "2026-05-10"
    },
    {
      "id": 4,
      "title": "La French Tech Bourgogne-Franche-Comté lance un nouveau dispositif : Meet Your VC !",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/actualites/programmes-french-tech/la-french-tech-bourgogne-franche-comte-lance-un-nouvel-evenement-meet-your-vc/",
      "type": "official",
      "date": "2025-04-08"
    },
    {
      "id": 5,
      "title": "« Le Numérique » : un bâtiment de 3.000 m2 à 10,5 M€ bientôt au cœur de Planoise",
      "publisher": "macommune.info",
      "url": "https://www.macommune.info/le-numerique-un-batiment-de-3-000-m2-a-105-me-bientot-au-coeur-de-planoise/",
      "type": "press",
      "date": "2025-08-27"
    },
    {
      "id": 6,
      "title": "Un lieu totem du numérique en construction à Planoise",
      "publisher": "Ville de Besançon / Grand Besançon Métropole",
      "url": "https://www.grandbesancon.fr/un-lieu-totem-du-numerique-en-construction-a-planoise/",
      "type": "official",
      "date": "2023-11-16"
    },
    {
      "id": 7,
      "title": "Les 102 lauréats de la 5e promotion de French Tech Tremplin Incubation dévoilés à VivaTech",
      "publisher": "Mission French Tech",
      "url": "https://lafrenchtech.gouv.fr/fr/les-102-laureats-de-la-5e-promotion-de-french-tech-tremplin-incubation-devoiles-a-vivatech/",
      "date": "2026-07-03",
      "type": "official"
    },
    {
      "id": 8,
      "title": "Les entreprises lauréates de la 5e promotion de French Tech Tremplin Incubation et leurs Capitales ou Communautés French Tech de rattachement (PDF)",
      "publisher": "Mission French Tech",
      "url": "https://lafrenchtech.gouv.fr/app/uploads/2026/07/Les-entreprises-laureates-de-la-5e-promotion-de-French-Tech-Tremplin-Incubation-et-leurs-Capitales-ou-Communautes-French-Tech-de-rattachement.pdf",
      "date": "2026-07-03",
      "type": "official"
    }
  ]
};
